import styled from 'styled-components';
import { LG_COLOR, WHITE_COLOR } from 'containers/App/constants';

interface TableStyleProps {
  loading: string;
}

export const TableStyle = styled.div<TableStyleProps>`
  padding: 10px;
  text-align: center;
  overflow-y: scroll;
  position: relative;

  ${({ loading }) => {
    if (loading) {
      return `
      &::before {
      content: 'Loading ...';
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      font-size: 1.5rem;
      top: 10px;
      left: 10px;
      z-index: 99;
      width: calc(100% - 20px);
      height: calc(100% - 20px);
      background-color: #00000034;
    }
      `;
    }
  }}

  table {
    width: 100%;
    border-spacing: 0;
    border: 1px solid silver;
    tr {
      :nth-child(even) {
        background-color: #f2f2f2;
      }
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }
    th {
      margin: 0px;
      padding: 1rem;
      border-bottom: 1px solid silver;
      border-right: 1px solid silver;
      background: ${LG_COLOR};
      color: ${WHITE_COLOR};
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      gap: 10px;
      :last-child {
        border-right: 0;
      }
      svg {
        font-size: 1.5rem;
      }
      .column-header {
        width: 100% !important;
      }
      .column-filter {
        width: 100% !important;
      }
    }
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid silver;
      border-right: 1px solid silver;
      :last-child {
        border-right: 0;
      }
    }
  }
  .pagination {
    justify-content: space-between;
    align-items: stretch;
    flex-wrap: wrap;
    box-sizing: border-box;
    padding: 0rem;
    border: 1px solid silver;
  }
`;
